<template>
    <div class="row advertising-space" v-if="false">
        <div class="col-12 w-100 overflow-auto p-4">
            <div class="advertising-space-banner">
                <!-- Revive Adserver iFrame Tag - Generated with Revive Adserver v5.0.4 -->
                <iframe id='ac0266ed' name='ac0266ed' src='http://revive.ember.ltd/www/delivery/afr.php?zoneid=3&amp;cb=7' frameborder='0' scrolling='no' width='468' height='60' allow='autoplay'>
                    <a href='http://revive.ember.ltd/www/delivery/ck.php?n=a4ac822c&amp;cb=7' target='_blank'>
                        <img src='http://revive.ember.ltd/www/delivery/avw.php?zoneid=3&amp;cb=7&amp;n=a4ac822c' border='0' alt='' />
                    </a>
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'advertising-space',
}
</script>
